import { DEDUCTIONS } from "..";
import { apiInstance } from "../config/apiInstance";

export type PutDeductionRequest = {
  conceptCode: string;
  conceptDescription: string;
  accountingAccount: string;
  percentage: number;
  fiscalYear: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  operatingIndicator: string;
  beneficiary: string;
  beneficiaryName: string;
};

export type PutDeductionResponse = {
  id: number;
  conceptCode: string;
  conceptDescription: string;
  accountingAccount: string;
  percentage: number;
  fiscalYear: number;
  effectiveStartDate: string;
  effectiveEndDate: string;
  operatingIndicator: string;
  beneficiary: string;
  beneficiaryName: string;
};

export const putDeduction = async (
  id: number,
  data: PutDeductionRequest,
): Promise<PutDeductionResponse> => {
  const response = await apiInstance.put<PutDeductionResponse>(
    `${DEDUCTIONS}/${id}`,
    data,
  );
  return response.data;
};
